import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { consentConstant } from "../../constants/constants";
import { ConsentComponent } from "../common/ConsentComponent";
import { ConsentSucessComponent } from "../common/ConsentSucessComponent";
import { AppDispatch, RootState } from "../../store/store";
import {
  UpdateConsentConditionAsync,
  fetchConsentDataAsync,
} from "../../store/thunks/ConsentThunk";
import { STATUS } from "../../store/slices/userDetailslice";
import Loader from "../common/styles/Loader";
import { ConsentRefreshComponent } from "../common/ConsentRefreshComponent";
import LoaderPopupModel from "../common/LoaderPopup";

interface Tab {
  label: string;
}

const tabs: Tab[] = [
  { label: consentConstant.privacyPolicy },
  { label: consentConstant.termsAndConditions },
];

export const Consent = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [activeTab, setActiveTab] = useState(0);
  const [showSucessComponent, setShowSucessComponent] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [refreshScreen, setRefreshScreen] = useState(false);

  const consentStatus = useSelector((state: RootState) => state.consentDetails);
  const consentDetailsdata = useSelector(
    (state: RootState) => state.consentDetails.consentDetails
  );

  const url = window.location.hash;
  const consentKey = url.split("?")[1]?.toString();

  const handleTabClick = (index: number) => setActiveTab(index);
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setIsChecked(e.target.checked);

  const handelSubmitButton = async () => {
    const data = { key: consentKey, status: "ACCEPTED" };
    setShowLoader(true);
    await dispatch(UpdateConsentConditionAsync(data));
  };

  useEffect(() => {
    if (consentStatus.consentSubmitStatus === STATUS.SUCCESS) {
      setShowLoader(false);
      setShowSucessComponent(false);
    } else if (consentStatus.consentSubmitStatus === STATUS.FAILED) {
      setShowLoader(false);
      console.error("Error in submitting");
    }
  }, [consentStatus]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchConsentDataAsync(consentKey));
    };
    fetchData();
  }, [refreshScreen]);
  
  function base64ToUtf8(base64String: string): string {
    const binaryString = atob(base64String); // Still gives Latin-1 binary string
    const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
    return new TextDecoder("utf-8").decode(bytes);
  }
  
  useEffect(() => {
    if (consentDetailsdata?.privacyPolicy) {
      const htmlString = base64ToUtf8(consentDetailsdata.privacyPolicy);
      setHtmlContent(htmlString.toString());
    }
  }, [consentDetailsdata]);

  const renderTabs = () => (
    <div className="flex pr-8 pt-4">
      {tabs.map((tab, index) => (
        <div className="pl-4" key={index}>
          <div className="flex flex-col justify-start">
            <div
              data-testId={`tab ${index}`}
              className={`flex items-center font-nunito cursor-pointer ${
                activeTab === index ? "text-primary text2" : "roleButton"
              }`}
              style={{ fontWeight: activeTab === index ? 700 : 400 }}
              onClick={() => handleTabClick(index)}
            >
              <span>{tab.label}</span>
            </div>
            <hr
              className={`${
                activeTab === index
                  ? "bg-primary h-[4px]"
                  : "bg-SearchBarBackgroundColor h-[1px]"
              }`}
            />
          </div>
        </div>
      ))}
    </div>
  );

  const renderCheckboxSection = () => (
    <div className="flex pl-4">
      <div className="pt-1">
        <label className="container">
          <input
            type="checkbox"
            className="checkmarks"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <span className="checkmark"></span>
          <span className="body1 text-primary ml-6"></span>
        </label>
      </div>
      <div>
        <span className="text-inputTextColor quickLinksDescription">
          {consentConstant.checkBoxDetails}
          <span className="text-primary staffListHeader">
            {" "}
            {consentConstant.privacyPolicy}{" "}
          </span>
          {consentConstant.andAgreeToThe}
          <span className="text-primary staffListHeader">
            {" "}
            {consentConstant.termsAndConditions}{" "}
          </span>
          .
        </span>
      </div>
    </div>
  );
  console.log(htmlContent);
  const renderSubmitButton = () => (
    <div
      className={`${
        isChecked
          ? "bg-primary text-whiteColor cursor-pointer"
          : "bg-sideMenuHelpBox text-popUpTitleColor cursor-not-allowed"
      } text-center consentSubmitButton py-3`}
      onClick={isChecked ? handelSubmitButton : () => {}}
    >
      {consentConstant.submitConsent}
    </div>
  );

  const renderConsentContent = () => {
    if (
      consentStatus?.consentDetailsStatus === STATUS.LOADING ||
      consentStatus?.consentDetailsStatus === STATUS.IDLE
    ) {
      return (
        <LoaderPopupModel
          isOpen={consentStatus.consentDetailsStatus === STATUS.LOADING}
        />
      );
    }

    if (consentStatus?.consentDetailsStatus === STATUS.SUCCESS) {
      return (
        <>
          <div className="px-3 py-4">
            <ConsentComponent
              title={
                activeTab === 0
                  ? consentConstant.privacyPolicy
                  : consentConstant.termsAndConditions
              }
              description={htmlContent}
            />
          </div>
          {renderCheckboxSection()}
          <div className="px-4 pt-6 pb-12">
            {renderSubmitButton()}
            <div className="text-redColor text-xs pt-1">
              {consentStatus.consentSubmitErrorMessage}
            </div>
          </div>
        </>
      );
    }

    return (
      <div className="px-4 py-7">
        <ConsentRefreshComponent
          setRefreshScreen={setRefreshScreen}
          consentDetailsErrorMessage={
            consentStatus?.consentDetailsErrorMessage
          }
        />
      </div>
    );
  };

  const renderLoaderOverlay = () =>
    showLoader && (
      <div className="fixed z-10 inset-0 flex h-dvh justify-center">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-blackColor bg-opacity-35" />
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <Loader />
      </div>
    );

  return (
    <div className="xl:hidden">
      {showSucessComponent ? (
        <div>
          <header className="bg-primary pt-[3vh]">
            <div className="consentHeaderText text-whiteColor px-4 pb-6">
              {consentConstant.consentHeader}
            </div>
          </header>
          <div className="bg-SearchBarBackgroundColor">
            {renderTabs()}
            {renderConsentContent()}
          </div>
          {renderLoaderOverlay()}
        </div>
      ) : (
        <ConsentSucessComponent />
      )}
    </div>
  );
};
